/* eslint-disable react/prop-types */
import React from "react";
import { Link } from "react-router-dom";
import { INVOICE_DETAILS, CLIENT_DETAILS } from "../../../../../route/paths";
import {
  formatCurrency,
  formatFTNumber,
  formatDateWithDayjs
} from "../../../../../utils/utils";
import {
  CURRENCY_FORMAT,
  NEGATIVE_SIGN,
  DD_MMM_YYYY,
  ZERO_NUMBER
} from "../../../../../utils/constants/appConstants";

export const COLUMNS = [
  {
    Header: "FT No",
    accessor: "quoteId",
    Cell: ({ value }) => (
      <Link to={INVOICE_DETAILS(value)}>
        {formatFTNumber(value) || NEGATIVE_SIGN}
      </Link>
    )
  },
  {
    Header: "Customer",
    accessor: "customerName",
    Cell: ({ value, row }) =>
      row?.original?.userAccountId ? (
        <Link to={CLIENT_DETAILS(row.original.userAccountId)}>
          {value || NEGATIVE_SIGN}
        </Link>
      ) : (
        value || NEGATIVE_SIGN
      )
  },
  {
    Header: "Invoice Status",
    accessor: "quoteStatus",
    Cell: ({ value }) => value || NEGATIVE_SIGN
  },
  {
    Header: "Repay Date",
    accessor: "repaymentDueDate",
    Cell: ({ value }) =>
      formatDateWithDayjs(value, DD_MMM_YYYY) || NEGATIVE_SIGN
  },
  {
    Header: "Total owing",
    accessor: "totalOwing",
    Cell: ({ value }) => {
      if (value == null) return NEGATIVE_SIGN;
      const isNegative = value < ZERO_NUMBER;
      const formattedValue = formatCurrency(Math.abs(value));
      return (
        <span>
          {isNegative ? NEGATIVE_SIGN : ""}
          {CURRENCY_FORMAT}
          {formattedValue}
        </span>
      );
    }
  }
];
